import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Formik, Form, Field } from 'formik'
import { Input } from '@wellbeingxltd/fe-lib/components'
import { GET_STORE } from '@wellbeingxltd/fe-lib/constants'
import { Button, Toolbar } from 'components'
import LoginHint from './LoginHint'
import AuthActions from 'store/models/auth'
import schema from './schema'
import '../styles.scss'

const Login = () => {
    const history = useHistory()
    const dispatch = useDispatch()
    const { loadingLogin, logInFailedErrorMessage } = useSelector(GET_STORE.AUTH)
    let { hash, state } = history.location

    const [initialValues, setInitialValues] = useState({ email: '', password: '' })

    useEffect(() => {
        if (!!state?.email && !!state?.password) {
            setInitialValues({ email: state.email, password: state.password })
            onSubmit({ email: state.email, password: state.password })
        }
    }, [])

    const onSubmit = ({ email, password }) => {
        dispatch(AuthActions.logIn(email, password, history))
    }

    return (
        <div className="landing-container">
            <Toolbar buttonTitle="Sign up a new supplier" onButtonClicked={() => history.push('/signup')} />
            <div className="landing-card">
                <h1>Login</h1>
                {hash === '#success' && <p className="stripe-success">Stripe setup was successful. Please login to continue.</p>}
                <Formik enableReinitialize={true} initialValues={initialValues} validationSchema={schema} onSubmit={onSubmit}>
                    <Form>
                        <Field name="email">
                            {({ field, form, meta }) => (
                                <Input
                                    id="email"
                                    type="email"
                                    touched={meta.touched}
                                    error={meta.error}
                                    {...field}
                                    labelAbove="Work email"
                                    autoComplete="current-email"
                                    onBlurCapture={e => form.setFieldValue(e.target.name, e.target.value.trim().toLowerCase())}
                                />
                            )}
                        </Field>
                        <Field name="password">
                            {({ field, meta }) => (
                                <Input
                                    id="password"
                                    type="password"
                                    touched={meta.touched}
                                    error={meta.error}
                                    {...field}
                                    labelAbove="Password"
                                    autoComplete="current-password"
                                />
                            )}
                        </Field>
                        <Button loading={loadingLogin} type="submit" className="landing-card-button">
                            LOGIN
                        </Button>
                        {logInFailedErrorMessage && <div className="input-error-label">*{logInFailedErrorMessage}</div>}
                    </Form>
                </Formik>
                <div
                    style={{ textDecorationLine: 'underline', fontSize: 16, marginTop: 16, cursor: 'pointer' }}
                    onClick={() => history.push('/forgotPassword')}
                >
                    Forgot password?
                </div>
                <div className="landing-card-separator" />
                <h2>New to Betterspace?</h2>
                <Button className="landing-card-button" onClick={() => history.push('/signup')}>
                    SIGN UP A NEW SUPPLIER
                </Button>
                <LoginHint />
            </div>
        </div>
    )
}

export default Login
